import React from "react";
import { SimpleShowLayout, TextField } from "react-admin";

const GirlsVolleyballTab = (props) => {
  return (
    <SimpleShowLayout record={props.record[props.side]}>
      <TextField source="season.team.name" />
      <TextField source="id" />
      <TextField source="girlsvolleyball.id" />
      <TextField source="girlsvolleyball.finalScore" />
      <TextField source="girlsvolleyball.game1Points" />
      <TextField source="girlsvolleyball.game2Points" />
      <TextField source="girlsvolleyball.game3Points" />
      <TextField source="girlsvolleyball.game4Points" />
      <TextField source="girlsvolleyball.game5Points" />
      <TextField source="girlsvolleyball.kills" />
      <TextField source="girlsvolleyball.aces" />
      <TextField source="girlsvolleyball.blocks" />
      <TextField source="girlsvolleyball.digs" />
      <TextField source="girlsvolleyball.assists" />
    </SimpleShowLayout>
  );
};

export default GirlsVolleyballTab;
